import { motion } from "framer-motion";
import { SERVICES } from "@/data/site";
import { SectionHead } from "./Reveal";
import { EASE } from "@/lib/scroll";

const ImageCard = ({ s }) => (
  <div className="relative h-full overflow-hidden rounded-[24px] bg-[#DDE3D5]">
    <img src={s.img} alt={`${s.title} – K&A Gartenservice Bottrop`} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.06]" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
    <div className="relative h-full flex flex-col justify-between p-6 sm:p-7 text-white">
      <span className="w-11 h-11 rounded-full bg-white/15 backdrop-blur-md flex items-center justify-center"><s.icon className="w-5 h-5" strokeWidth={1.6} /></span>
      <div>
        <h3 className={`font-head font-semibold tracking-tight leading-tight ${s.size === "lg" ? "text-2xl sm:text-3xl" : "text-xl"}`}>{s.title}</h3>
        <p className="mt-2 max-w-md text-sm sm:text-[15px] text-white/85 leading-relaxed">{s.text}</p>
      </div>
    </div>
  </div>
);

const IconCard = ({ s }) => (
  <div className={`h-full rounded-[24px] p-6 sm:p-7 flex flex-col justify-between border transition-colors duration-500 ${s.accent ? "bg-[#111511] border-[#111511] text-white" : "bg-white border-[#111511]/[0.07] text-[#111511] group-hover:border-[#111511]/20"}`}>
    <span className={`w-11 h-11 rounded-full flex items-center justify-center transition-transform duration-500 group-hover:-rotate-12 ${s.accent ? "bg-[#9CC26A] text-[#111511]" : "bg-[#EEF3E6] text-[#2F5D3A]"}`}>
      <s.icon className="w-5 h-5" strokeWidth={1.6} />
    </span>
    <div className="mt-10">
      <h3 className="font-head text-xl font-semibold tracking-tight leading-tight">{s.title}</h3>
      <p className={`mt-2 text-sm sm:text-[15px] leading-relaxed ${s.accent ? "text-[#C9CEC6]" : "text-[#5B615A]"}`}>{s.text}</p>
    </div>
  </div>
);

export const Services = () => (
  <section id="leistungen" data-testid="services-bento-section" className="py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <SectionHead eyebrow="Leistungen" lines={["Gartenpflege,", <span className="text-[#5E8C3A]">die man sieht.</span>]}
        text="Unser Gartenservice in Bottrop konzentriert sich auf das Wesentliche: einfache, regelmäßige Gartenpflege für Privatgärten – gründlich erledigt und ordentlich hinterlassen." />
      <div className="mt-14 lg:mt-20 grid grid-cols-1 md:grid-cols-12 gap-4">
        {SERVICES.map((s, i) => (
          <motion.div key={s.key} data-testid={`service-card-${s.key}`}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: (i % 4) * 0.07 }} whileHover={{ y: -5 }}
            className={`group col-span-1 ${s.span} ${s.size === "lg" ? "h-[380px] lg:h-[480px]" : "min-h-[250px] lg:h-[290px]"}`}>
            {s.img ? <ImageCard s={s} /> : <IconCard s={s} />}
          </motion.div>
        ))}
      </div>
      <p className="mt-6 text-sm text-[#5B615A]">Keine Baumfällungen oder Landschaftsbau – wir sind spezialisiert auf zuverlässige, regelmäßige Gartenpflege.</p>
    </div>
  </section>
);
